// Scrolls once the target exists (handles route changes where the page mounts later).
export const scrollToSection = (id, timeout = 4000) => {
  const start = Date.now();
  const attempt = () => {
    const el = id ? document.getElementById(id) : document.body;
    if (el) return id ? el.scrollIntoView({ behavior: "smooth" }) : window.scrollTo({ top: 0, behavior: "smooth" });
    if (Date.now() - start < timeout) setTimeout(attempt, 100);
  };
  attempt();
};
